export const LOAD_COURSES = 'ibw/LOAD_COURSES';
export const SET_COURSES = 'ibw/SET_COURSES';
export const SET_TOTAL = 'ibw/SET_TOTAL';
export const SET_FACETS = 'ibw/SET_FACETS';
export const SET_PRESET_LOCATION = 'ibw/SET_PRESET_LOCATION';
export const SET_PRESET_DEGREE = 'ibw/SET_PRESET_DEGREE';
export const SET_PRESET_STRUCTURE = 'ibw/SET_PRESET_STRUCTURE';
export const SET_APP_IS_MOBILE = 'ibw/SET_APP_IS_MOBILE';
export const SET_APP_IS_LOADING = 'ibw/SET_APP_IS_LOADING';
